// ** Gatsby
import { Link } from "gatsby"
import { parseLink } from "../../utils/helpers"

const SectionLink = ({ link, children, className }: any) => {
  if (!link) return null;

  if (link._type === 'linkExternal') {
    if (link.newWindow) {
      return <a href={link.url} target="_blank" className={className}>{children ? children : link.title}</a>
    } else {
      return <a href={link.url} className={className}>{children ? children : link.title}</a>
    }
  }

  if (link._type === "linkInternal") {
    return <Link to={parseLink(link)} className={className}>{children ? children : link.title}</Link>
  }

  return null
}

export default SectionLink